export const AllowMobileUrlList = [
  "/ticket",
  "",
  "/",
  "/handy-tech-ai",
  "/history",
  "/questionType",
];
export const AllowMobileTagList = ["handy-tech-ai"];

export const OnlyCnWhiteUrlList = [];
export const OnlyCnWhiteTagList = ["technicalSupport", "IMSupport", "repair"];

export const MultipleLangTagList: string[] = [
  "survey",
  "transit",
  "handy-tech-ai",
  "im",
  "/history",
];
export const MultipleLangUrlList: string[] = ["", "/", "/questionType"];

export const CLOUDFRONT_VIEWER_COUNTRY = "cloudfront-viewer-country";
export const CF_IP_COUNTRY = "cf-ipcountry";
export const X_FORWARDED_HOST = "x-forwarded-host";
export const HOST = "host";

export const LangInterfaceOptionsSet: { [key: string]: string } = {
  en: "en-US",
  cn: "zh-CN",
  "en-US": "en-US",
  "zh-CN": "zh-CN",
};

// 国家码
export const enum CountryCodeEnum {
  "US" = "US",
  "CN" = "CN",
}

// 官网中文域名
export const CN_BUM_BU_LAB_DOMAIN_NAME = "bambulab.cn";
// 官网中文域名-非生产
export const CN_BUM_BU_LAB_DOMAIN_NAME_NO_PROD = "bambulab.net";
// 官网英文域名
export const EN_BUM_BU_LAB_DOMAIN_NAME = "bambulab.com";

// 中文域名
export const CN_DOMAIN_NAME = "support.bambulab.cn";
// 英文域名
export const US_DOMAIN_NAME = "support.bambulab.com";

// im-英文
const IM_URL_EN =
  "https://bblcs.udeskglobal.com/im_client/?web_plugin_id=1989&group_id=1835&language=en-us";
// im-中文
const IM_URL_CN =
  "https://bblcs.s5.udesk.cn/im_client/?web_plugin_id=1972&group_id=1088";

// im测试链接
const IM_URL_TEST =
  "https://1805974.s5.udesk.cn/im_client/?web_plugin_id=2059&group_id=1361";

export const getIMLink = (lang: "cn" | "en") => {
  const env = process.env.NEXT_PUBLIC_ENV_FLAG?.toLocaleLowerCase() || "prod";
  if (env === "test" || process.env.NODE_ENV === "development") {
    return IM_URL_TEST;
  } else {
    return lang === "cn" ? IM_URL_CN : IM_URL_EN;
  }
};

// 通用工单 相对链接
export const GeneralTicketRelativeUrl = "/my/support/general-inquiry";
// 技术工单 相对链接
export const TechTicketRelativeUrl = "/my/support/tickets/create";

const MW_TICKET_URL_US = "https://makerworld.com/en/my/support/tickets/create";
const MW_TICKET_URL_CN =
  "https://makerworld.com.cn/en/my/support/tickets/create";

export const getMarkerWorldTicketUrl = () => {
  if (typeof window === "undefined") return MW_TICKET_URL_US;

  const { hostname } = window.location;
  switch (hostname) {
    case US_DOMAIN_NAME:
      return MW_TICKET_URL_US;
    case CN_DOMAIN_NAME:
      return MW_TICKET_URL_CN;
    default:
      return MW_TICKET_URL_US;
  }
};

// 是否海外
export const isOversea = () =>
  (process.env.NEXT_PUBLIC_REGION || "OR-PROD").toLocaleLowerCase() ===
  "or-prod";

// test模拟用
// 中文域名
// export const CN_DOMAIN_NAME = 'test-support.bambulab.net';
// // 英文域名
// export const US_DOMAIN_NAME = 'test-support.bambu-lab.com';

// 服务端版本 - 使用 headers
export const getLiveChatUrlServer = (headers: Headers) => {
  const hostname = headers.get(X_FORWARDED_HOST) || headers.get(HOST) || "";
  // 不去udesk了，全部去自己的im
  const imUrl = `https://${hostname}/liveChat/`;
  return imUrl;
};

// 客户端版本 - 使用 window.location
export const getLiveChatUrl = () => {
  const hostname = window.location.hostname;
  // 不去udesk了，全部去自己的im
  const imUrl = `https://${hostname}/liveChat/`;
  return imUrl;
};
